<mat-card fxLayoutGap class="p-3">
  <div class="fw-semibold fs-4 mb-2">Carica Liberatoria</div>
  <div class="v-spacer"></div>
  <div class="row m-0 p-0">
    <form [formGroup]="this.userDocumentForm" enctype="multipart/form-data">
      <input type="file" formControlName="file" class="form-control dea-form-input mb-1" placeholder="Seleziona un file"
        accept="image/png,image/jpeg,.pdf" (change)="this.onFileChange($event)" />
      <div class="fw-lighter mb-3" style="font-size: 0.5rem;">
        Formati accettati: PDF - PNG/JPG/JPEG | Dimensione Massima: 48Mb x 1
      </div>
      <div class="mb-3 text-danger">{{this.error?.message || this.errorMessage}}</div>
    </form>
  </div>
  <div class="mt-3 gap-2" mat-dialog-actions align="center">
    <button class="px-5 py-1" mat-stroked-button (click)="this.onDismiss()">Annulla</button>
    <button *ngIf="!this.isUploading" class="px-5 py-1" mat-flat-button color="primary" (click)="this.onConfirm()">
      Carica
    </button>
    <button *ngIf="this.isUploading" class="px-5 py-1" mat-flat-button disabled>
      <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon> Caricamento
    </button>
  </div>
</mat-card>